const translations = {
  general: {
    documentTitle: 'Gebrauchtwagen suchen',
  },
  compare: {
    back: 'Der Rücken',
    searchMore: 'Weitere Gebrauchtwagen finden',
    pageTitle: 'Gebrauchtwagen vergleichen',
    photo: 'Foto',
    emptyState: {
      title: 'Keine Fahrzeuge ausgewählt',
      desc: 'Es wurden (noch) keine Fahrzeuge zum Vergleich ausgewählt. Suchen Sie ein Fahrzeug und klicken Sie auf "Vergleichen", um es hinzuzufügen.',
      button: 'Gebrauchtwagen suchen',
    },
  },
  vehicle: {
    mileageUnit: 'km',
    energyPowerUnit: 'kW',
    horsePowerUnit: 'PS',
    type: 'Version',
    vehicleType: 'Fahrzeugtyp',
    price: 'Preis',
    year: 'Baujahr',
    mileage: 'Kilometerstand',
    fuelType: 'Kraftstoff',
    enginePower: 'Leistung',
    transmission: 'Getriebe',
    license: 'Nummernschild',
    body: 'Karosserie',
    numberDoors: 'Anzahl der Türen',
    lining: 'Polster',
    color: 'Außenfarbe',
    numberCilinders: 'Menge Zylinder',
    sizes: 'Maße',
    engineCapacity: 'Hubraum',
    engineVolume: 'Motorleistung',
    engineCapacityUnit: 'cc',
    weight: 'Gewicht',
    maxTowingWeight: 'Max. Gewicht ziehen',
    weightUnit: 'kg',
    volumeUnit: 'L',
    fuelConsumption: 'Verbrauch auf {amount} km',
    taxMargin: 'MwSt/Marge',
    btwMarge: 'MwSt/Marge',
    energyLabel: 'Energieeffizienzklasse',
    roadTax: 'Kfz-Steuer',
    perQuarterEstimation: 'pro Quartal (Schätzung)',
    inclTax: 'inkl. MwSt',
    exclTax: 'exkl. MwSt',
    finance: {
      from: 'ab',
      privateLeaseFrom: 'Privates Leasing ab',
      perMonth: 'p/Monat',
    },
    actions: {
      offer: 'Angebot anfordern',
      tradeIn: 'Eintauschwert berechnen',
      privateLease: 'Privaten Mietvertrag beantragen',
      finance: 'Finanzierung beantragen',
      testDrive: 'Probefahrt beantragen',
      callMeBack: 'Ruf mich zurück',
      buy: 'Kaufe jetzt',
      compare: 'Vergleichen',
      appointment: 'Einen Termin machen',
      print: 'Drucken Sie dieses Fahrzeug aus',
    },
    warranties: {
      napCheck: 'NAP-Check',
      hundredPercentMaintained: '100% gepflegt',
      carPass: 'Car-Pass',
      bovagDescription:
        'Je nach gewähltem Lieferpaket können folgende Garantien mit dem Fahrzeug geliefert werden. Kontaktieren Sie uns für Informationen zu den spezifischen Lieferpaketen.',
      bovag40: 'BOVAG 40-Punkte-Check',
      bovagAfleverbeurt: 'BOVAG-Lieferung',
      bovag6months: '6 Monate BOVAG Garantie',
      bovag12months: '12 Monate BOVAG Garantie',
      bovag24months: '24 Monate BOVAG Garantie',
      autotrust: 'Autotrust',
      vakgarant: 'Vakgarant',
      vweOccasionPlan: 'VWE Occasion Garant Plan',
      cargarantie: 'Cargarantie',
      additionalWarrantyButton: 'Unsere Garantiebedingungen',
    },
  },
  loop: {
    view: 'Ansehen',
    viewCar: 'Auto ansehen',
    compare: 'Vergleichen',
  },
  single: {
    back: 'Zurück zu allen Gebrauchtwagen',
    contactTitle: 'Direkten Kontakt',
    shareTitle: 'Teilen Sie dieses Auto',
    shareText: 'Sehen%20Sie%20sich%20dieses%20Auto%20an%20',
    route: 'Route',
    email: 'Email',
    tabs: {
      specs: 'Spezifikationen',
      options: 'Optionen',
      desc: 'Beschreibung',
      warranty: 'Gewährleistung',
      deliverOptions: 'Lieferpakete',
    },
    deliverOptions: {
      description: 'Beschreibung',
      price: 'Preis',
      inclTax: 'inkl. MwSt',
      contents: 'Kapazität',
    },
    warranty: {
      moreInfo: 'Mehr Informationen',
    },
  },
  filters: {
    title: 'Gebrauchtwagen suchen',
    modalTitle: 'Suchfilter einrichten',
    modalButton: 'Ergebnisse anzeigen',
    compare: 'Vergleichen',
    filter: 'Filter',
    allBrands: 'Alle Marken',
    allModels: 'Alle Modelle',
    brand: 'Marke',
    model: 'Modell',
    resetFilters: 'Filter löschen',
    emptyState: {
      title: 'Nichts gefunden',
      desc: 'Wir konnten keine Fahrzeuge finden, die den angegebenen Kriterien entsprechen. Passen Sie die Filter an oder klicken Sie auf die Schaltfläche, um neu zu beginnen.',
      button: 'Alle Filter zurücksetzen',
    },
    results: '{count} Ergebnis | {count} Ergebnisse',
  },
  search: {
    inputTitle: 'Suchbegriff',
    inputPlaceholder: 'Suchen...',
    searchIn: 'Suche hinein',
    searchInAll: 'Alle Fahrzeuge',
    searchInSelection: 'Fahrzeuge aus Auswahl',
    submit: 'Suchen',
  },
  sort: {
    relevance: 'Relevanz',
    alphabetically: 'Alphabetisch',
    priceAsc: 'Preis (niedrig - hoch)',
    priceDesc: 'Preis (hoch-niedrig)',
    dateAddedDesc: 'Datum hinzugefügt (neu - alt)',
    mileageAsc: 'Kilometerstand (niedrig - hoch)',
  },
  forms: {
    noTranslationAvailable:
      'Leider kann dieser Teil der Website nicht in Ihrer Sprache bereitgestellt werden. Bitte kontaktieren Sie uns, wenn Sie Hilfe benötigen.',
    errors: {
      requiredFields: 'Füllen Sie alle erforderlichen Felder aus',
      requiredFieldSingle: 'Dieses Feld ist erforderlich',
      acceptTerms: 'Sie müssen den Bedingungen zustimmen',
      validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      noAddressFound: {
        text: 'Die Adresse konnte nicht gefunden werden. Haben Sie die richtige Postleitzahl und Hausnummer eingegeben?',
        button: 'Manuell ausfüllen',
      },
      somethingWentWrong: 'Beim Senden der Anfrage ist etwas schief gelaufen. Versuchen Sie es später noch einmal.',
    },
    fields: {
      salutation: 'Anrede',
      salutationMale: 'Herr.',
      salutationFemale: 'Frau.',
      fullName: 'Vollständiger Name',
      name: 'Name',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail-Addresse',
      phone: 'Telefonnummer',
      address: 'Adresse',
      zip: 'Postleitzahl',
      houseNumber: 'Hausnummer',
      houseNumberSupplement: 'Zusatz',
      city: 'Stadt',
      street: 'Straßenname',
      birthDate: 'Geburtsdatum',
      mileage: 'Kilometerstand',
      comments: 'Kommentare',
      acceptTermsPre: 'Ich stimme dem zu',
      terms: 'geschäftsbedingungen',
      unknown: 'Unbekannt',
      submitRequest: 'Anfrage bestätigen',
      yes: 'Ja',
      no: 'Nein',
      companyName: 'Name der Firma',
    },
    testRide: {
      title: 'Probefahrt beantragen',
      preferenceDate: 'Bevorzugter Probefahrttermin',
      submit: 'Probefahrt beantragen',
    },
    appointment: {
      title: 'Einen Termin machen',
      preferenceDate: 'Bevorzugtes Datum',
      preferenceTime: 'Bevorzugte Zeit',
      submit: 'Einen Termin machen',
    },
    tradeIn: {
      title: 'Eintauschwert berechnen',
    },
    privateLease: {
      title: 'Privaten Mietvertrag beantragen',
      stepCalculator: 'Ihr privater Mietvertrag',
      stepPersonalDetails: 'Daten',
      stepConfirm: 'Bestätigen',
      leaseAmount: 'Leasingbetrag',
      from: 'aus',
      perMonth: 'pro Monat',
      calculationDisclaimer: 'basierend auf {mileage} km pro Jahr und einer Vertragslaufzeit von {duration} Monaten',
      calculatorTitle: 'Stellen Sie Ihren privaten Mietvertrag zusammen',
      calculatorDesc:
        'Die Miethöhe hängt von mehreren Faktoren ab. Fordern Sie hier ein Angebot an und erfahren Sie Ihre persönliche Leasingsumme pro Monat.',
      duration: 'Gewünschte Dauer',
      months: 'Monate',
      mileagePerYear: 'Kilometer pro Jahr',
      damageFreeYears: 'Anzahl anspruchsfreier Jahre',
      prepayment: 'Kaution',
      request: 'Anfordern',
      toConfirmStep: 'Bestätigen',
      confirmDesc:
        'Überprüfen Sie hier Ihre Angaben und bestätigen Sie anschließend den Antrag, um ihn abzusenden. Wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen.',
      leaseDetails: 'Mietdetails',
      personalDetails: 'Persönliche Informationen',
      edit: 'ändern',
    },
    callMeBack: {
      title: 'Ruf mich zurück',
      submit: 'Ruf mich zurück',
    },
    finance: {
      title: 'Finanzierung berechnen',
      consumer: 'Privatperson',
      business: 'Für das Geschäft',
      vehiclePrice: 'Kaufpreis des Fahrzeugs',
      prepaymentTradeIn: 'Kaution / Inzahlungnahme',
      creditSumLoanAmount: 'Kreditbetrag / Darlehensbetrag',
      durationInMonths: 'Dauer in Monaten',
      finalSum: 'Fazit',
      finalSumError: 'Kein Abschluss möglich, der zu finanzierende Mindestbetrag beträgt',
      monthlyFee: 'Monatliche Menge',
      calculationDisclaimer: 'Der Berechnung liegt ein {interestRate}% Jahreseffektivzins zugrunde.',
      askOffer: 'Angebot anfordern',
      stepCalculator: 'Ihre Finanzierung',
      stepPersonalDetails: 'Persönliche Informationen',
      stepConfirm: 'Bestätigen',
      financeDetails: 'Finanzierungsdetails',
      confirmDesc:
        'Überprüfen Sie hier Ihre Angaben und bestätigen Sie anschließend den Antrag, um ihn abzusenden. Wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen.',
    },
    offer: {
      title: 'Angebot anfordern',
      tradeInCar: 'Möchten Sie ein Auto eintauschen?',
      yourLicense: 'Ihr Nummernschild',
      submit: 'Angebot anfordern',
    },
    buy: {
      title: 'Kauf dieses Auto online',
      stepPersonalDetails: 'Daten',
      stepPaymentDelivery: 'Zahlungs-und Lieferbedingungen',
      stepConfirm: 'Bestätigen',
      personalDetailsDesc: 'Haben Sie Ihr Traumauto gefunden? Genial! Geben Sie unten Ihre Daten ein, um die Bestellung abzuschließen.',
      consumerOrBusiness: 'Handelt es sich um eine private oder geschäftliche Bestellung?',
      consumer: 'Privatperson',
      business: 'Für das Geschäft',
      ownerQuestion: 'Auf wessen Namen soll das Auto zugelassen werden?',
      ownerSelf: 'Mein eigener Name',
      ownerOther: 'Anderer Name',
      ownerDetails: 'Zuschreibung',
      driverLicenseCountry: 'Besitzen Sie einen niederländischen oder ausländischen Führerschein?',
      dutch: 'Niederländisch',
      foreign: 'Ausländisch',
      driverLicenseDisclaimer:
        'Für die Zuschreibung (Zulassung) des Autos benötigen wir Ihre Führerscheinnummer und Ihr Geburtsdatum. Führerscheinnummer nicht griffbereit? Kein Problem, wir werden Sie vor Auslieferung des Autos kontaktieren.',
      driverLicenseNumber: 'Führerscheinnummer',
      toPaymentDetails: 'Zahlungsmethode',
      paymentDetails: 'Zahlungsmethode',
      paymentDetailsDesc: 'Wie möchten Sie bezahlen, per Nachnahme oder Vorauskasse? Es ist deine Entscheidung.',
      paymentAtDelivery: 'Bezahlung bei Zustellung',
      paymentAtDeliveryDesc: 'Sie zahlen per Internet-Banking bei der Fahrzeugübergabe.',
      ideal: 'Zahlungsaufforderung',
      idealDesc: 'Sie bezahlen einfach und sicher mit einem Link, den Sie per E-Mail erhalten.',
      bankTransfer: 'Banküberweisung',
      bankTransferDesc: 'Sie zahlen manuell per Banküberweisung, die Zahlungsdetails erhalten Sie per E-Mail.',
      delivery: 'Lieferung',
      deliveryDesc:
        'Wählen Sie hier, ob Sie das Auto nach Hause liefern lassen oder bei uns abholen möchten. Geben Sie dann einen gewünschten Liefertermin an, wir werden Sie kontaktieren, um ihn zu bestätigen.',
      deliveryPackages: 'Lieferpacket',
      deliveryPackagesDesc: 'Bitte geben Sie unten an, welches Lieferpaket Sie Ihrem Kauf beifügen möchten.',
      home_delivery: 'Lassen Sie es sich nach Hause liefern',
      roadside_assistance: 'Pannenhilfe',
      insurance: 'Versicherung',
      extraOptions: 'Zusatzoptionen',
      extraOptionsDesc: 'Fügen Sie beim Kauf Ihres Gebrauchtwagens zusätzliche Optionen hinzu.',
      preferredDeliveryDate: 'Gewünschtes Lieferdatum',
      toConfirm: 'Bestätigen',
      confirmDesc:
        'Nachdem Sie Ihre Angaben überprüft haben, können Sie den Antrag absenden. Wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen.',
      personalDetails: 'Persönliche Informationen',
      edit: 'ändern',
    },
  },
}

export default translations
